module.exports = __webpack_public_path__ + "img/bg_function03_1_d.17c74196.png";